/* eslint-disable eqeqeq */
import { get } from 'lodash';
import { retrieveObjectMapper } from '../..';

export const transformBankBicCodes = (data = []) =>
  data?.map(item =>
    retrieveObjectMapper(item, ['ID:id', 'bank_name', 'bank_code', 'bic_code'])
  );

export const transformBankBicCode = (data = {}) =>
  retrieveObjectMapper(data?.data, [
    'ID:id',
    'bank_name',
    'bank_code',
    'bic_code',
    'display_order',
    'is_cda_supported',
  ]);

export const transformChildBankAccounts = ({
  data = [],
  bankBicCodes = [],
  childList = [],
  bankDocs = {},
  accountStateHistory = {},
}) =>
  data?.map(({ bank_account: bankAccount, giroApplication }) => {
    const child = childList?.find(({ id }) => id === bankAccount?.fk_child);
    const bankBicCode = bankBicCodes?.find(
      ({ ID }) => ID === bankAccount?.fk_bank_bic_code
    );

    return {
      BankAccount: {
        child: retrieveObjectMapper(child, [
          'firstname',
          'lastname',
          'birth_certificate',
        ]),
        bankBicCode,
        documentTypes: {
          data: bankDocs?.[bankAccount?.id],
        },
        bankAccountStateHistories: {
          data: accountStateHistory?.[bankAccount?.id],
        },
        ...retrieveObjectMapper(bankAccount, [
          'ID:id',
          'fk_child',
          'fk_bank_bic_code',
          'status:status_string',
          'child_name',
          'child_birth_certificate',
          'payer_account_number',
          'payer_account_name',
          'source:source_string',
          'remarks',
          'bill_reference_number',
          'is_cda',
          'is_sibling_cda',
          'sibling_name',
          'sibling_birth_certificate',
          'effective_from',
          'updated_at',
          'created_at',
        ]),
      },
      GiroApplication: retrieveObjectMapper(giroApplication, [
        'BankAccountNumber',
        'IsCDA',
        'MobilePhoneNumber',
        'MobilePhoneCountryCode',
        'ApplicationDate',
        'NameOfAccountHolders',
      ]),
    };
  });

export const transformBankDocumentTypes = (data = {}) => {
  const bankDocs = {};
  Object.keys(data)?.forEach(val => {
    bankDocs[parseInt(val, 10)] = data?.[val]?.map(item => ({
      ...retrieveObjectMapper(item, ['ID:id', 'label', 'fk_bank_account']),
      documentTypeConfig: retrieveObjectMapper(item?.document_type_config, [
        'ID:id',
      ]),
      documentTags: {
        data: item?.document_tag?.map(({ document }) => ({
          document: retrieveObjectMapper(document, [
            'filename',
            'uRL:url',
            'preSignedUrl:url_presigned_url',
            'url_encoded_presigned_url',
            'url_s3_presigned_url',
          ]),
        })),
      },
    }));
  });
  return bankDocs;
};

export const transformAccountHistory = (data = []) =>
  data?.map(item => ({
    ...retrieveObjectMapper(item, ['ID:id', 'fk_bank_account', 'updated_at']),
  }));

export const transformBankAccountStatusChangeReasons = (response = {}) => {
  const data = get(response, 'data', []);
  const totalCount = get(response, 'totalCount', 0);
  return {
    getBankAccountStatusChangeReasonsByStatus: {
      data: data?.map(item =>
        retrieveObjectMapper(item, ['ID:id', 'label', 'description'])
      ),
      totalCount,
    },
  };
};
